import { CONFIG } from '../../Config/config'

export const isClientRole = role =>
  [
    CONFIG.USER_ROLE.CLIENT_ADMIN,
    CONFIG.USER_ROLE.CLIENT,
    CONFIG.USER_ROLE.DISTRIBUTOR,
  ].indexOf(role) !== -1

export const isManagerRole = role =>
  [
    CONFIG.USER_ROLE.ADMIN,
    CONFIG.USER_ROLE.CITY_MANAGER,
    CONFIG.USER_ROLE.SPY,
  ].indexOf(role) !== -1
